<style scoped>
.color-panel-item {
  padding-left: 5px;
  padding-right: 5px;
}
.tag-item {
  float: left;
  margin: 4px;
}
.tag-card {
  margin-bottom: 12px;
}
.checkbox-item {
  padding-right: 4px;
}
.no-padding-top {
  padding-top: 0px;
}
.no-padding-bottom {
  padding-bottom: 0px;
}
.tag-page {
  padding: 10px;
}
</style>
<style scoped lang='scss'>
.fill-height {
  height: calc(100vh - 96px);
  overflow: hidden;
}
</style>

<template>
  <div class="tag-page">
    <mu-button small icon @click="onClickBack"><mu-icon value="keyboard_backspace" /></mu-button>
    <mu-row gutter>
      <mu-col span="3">
        <div v-if="flagFetchedTagTemplate">
          <div class="display-flex">
            <h1 class="item-title">{{$t('button.manage')}}</h1>
          </div>
          <div>
            <mu-checkbox class="checkbox-item" v-model="modelCustom" @change="onActionEditMedia" :label="$t('tag.custom')"></mu-checkbox>
          </div>
          <div v-if="modelCustom">
            <mu-checkbox class="checkbox-item" v-model="modelCommentMode" @change="onActionEditMedia" :label="$t('tag.commentMode')"></mu-checkbox>
          </div>
          <div class="clearfix" />
        </div>
        
        <div v-if="modelCustom">
          <div v-if="flagFetchedTagTemplate">
            <div class="display-flex">
              <h1 class="item-title">{{$t('tagTemplate.title')}}</h1>
            </div>
            <mu-card-text class="no-padding-top" v-if="templates.length">
              <TagTemplateItem :tagTemplate="item" v-for="(item, index) in templates" :mediaId="mediaId"/>
            </mu-card-text>
            <mu-card-text v-else>
              {{$t('tagTemplate.empty')}}
            </mu-card-text>
            <div class="clearfix" />
          </div>
        </div>
      </mu-col>
      <mu-col span="9" v-if="flagFetchedTag && flagFetchedMedia">
        <div class="tag-card">
          <div class="display-flex">
            <span class="item-title">{{$t('tag.title')}}</span>
            <span class="flex-item" />
            <mu-button v-if="modelCustom" color="primary" @click="onClickCreateTagTemplate"><mu-icon value="save" /> {{ $t('tagTemplate.create') }}</mu-button>
          </div>
          <mu-card-text>
            <transition name="fade" mode="out-in">
              <div v-if="modelCustom">
                <transition name="slide-fade" mode="out-in">
                  <transition-group tag="div" name="list-complete" v-if="tags.length">
                    <tag-item
                      v-for="(tag, index) in tags"
                      class="list-complete-item tag-item"
                      :key="index"
                      :tag="tag"
                      />
                    </transition-group>
                </transition>
                <div class="text-align-center full-width clearfix">
                  <mu-button @click="onClickCreateTag" color="primary">
                    <mu-icon value="add"></mu-icon> {{$t('button.add') + $t('space') + $t('tag.title')}}
                  </mu-button>
                </div>
              </div>
              <div class="text-align-center" v-else>{{$t('tag.disabled')}}
              </div>
            </transition>
          </mu-card-text>
          <div class="clearfix" />
        </div>
      </mu-col>
      <mu-dialog :title="$t('button.add') + $t('space') + $t('tag.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogCreate">
        <mu-form :model="form" label-width="500">
          <mu-form-item prop="input" :label="$t('tag.title')">
            <mu-text-field v-model="modelName"></mu-text-field>
          </mu-form-item>
        </mu-form>
        <div class="display-flex">
          <div class="color-panel-item">
            <div class="text-align-center">{{$t('tag.textColor')}}</div>
            <color-picker :value="modelColor" @input="onUpdateColor" />
          </div>
          <div class="color-panel-item flex-item">
            <div class="text-align-center">{{$t('button.preview')}}</div>
            <div>
              <mu-chip :style="styleTag">
                <span>{{computedName}}</span>
              </mu-chip>
            </div>
          </div>
          <div class="color-panel-item">
            <div class="text-align-center">{{$t('tag.bgColor')}}</div>
            <color-picker :value="modelBgColor" @input="onUpdateBgColor" />
          </div>
        </div>
        <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
        <mu-button slot="actions" flat color="primary" @click="onCreateTag" :disabled="isNameEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
      </mu-dialog>
      <mu-dialog :title="$t('tagTemplate.create')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogCreateTemplate">
        <mu-form :model="form" label-width="500">
          <mu-form-item prop="input" :label="$t('tagTemplate.title')">
            <mu-text-field v-model="modelTemplateName"></mu-text-field>
          </mu-form-item>
        </mu-form>
        <mu-button slot="actions" flat color="primary" @click="flagDialogCreateTemplate = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
        <mu-button slot="actions" flat color="primary" @click="onActionCreateTemplate" :disabled="isTemplateNameEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
      </mu-dialog>
    </mu-row>
  </div>
</template>

<script>

// Library
import { Compact } from 'vue-color'
import axios from "axios";

// Components
import TagItem from '@/components/Tag/TagItem.vue'
import TagTemplateItem from '@/components/Tag/TagTemplateItem.vue'

export default {
  name: 'TagPage',
  components: {
    TagItem,
    TagTemplateItem,
    'color-picker': Compact
  },
  props: {
    mediaId: {
      type: String,
      required: true
    }
  },
  data() {
    return {

      // Object
      tags: [],
      media: {}, // Media object
      form: {},
      templates: [],

      // Flag
      flagFetchedMedia: false, // Boolean variable for status of media fetched
      flagFetchedTag: false, // Boolean variable for status of tag fetched
      flagFetchedTagTemplate: false, // Boolean variable for status of tag template fetched
      flagDialogCreate: false, // Boolean variable for status of create dialog
      flagDialogCreateTemplate: false, // Boolean variable for status of create template dialog

      //Model
      modelName: "", // Bind with name input
      modelColor: {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      },
      modelBgColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 0.5
      },
      modelCustom: false,
      modelCommentMode: false,
      modelTemplateName: "",
    }
  },
  computed: {
    // Flag
    isNameEmpty() {
      if (this.modelName === "") {
        return true;
      } else {
        return false;
      }
    },
    isTemplateNameEmpty() {
      if (this.modelTemplateName === "") {
        return true;
      } else {
        return false;
      }
    },

    // String
    computedName() {
      if(this.isNameEmpty) {
        return this.$t('tag.title');
      } else {
        return this.modelName;
      }
    },

    // Array
    computedTagIds() {
      return this.tags.map(x => x._id);
    },

    // Style
    styleTag() {
      return {
        color: this.stringColor,
        backgroundColor: this.stringBgColor
      };
    },
    stringColor() {
      return "rgba(" + this.modelColor.r + ", " + this.modelColor.g + ", " + this.modelColor.b + ", " + this.modelColor.a + ")";
    },
    stringBgColor() {
      return "rgba(" + this.modelBgColor.r + ", " + this.modelBgColor.g + ", " + this.modelBgColor.b + ", " + this.modelBgColor.a + ")";
    },

    // Constant
    constTrue() {
      return true;
    },
    constFalse() {
      return false;
    },

    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
  },
  watch: {
    triggerRefresh() {
      this.fetchMedia();
    },
  },
  created() {
    this.fetchMedia();
  },
  methods: {
    // Fetch
    fetchMedia() {
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.media = response.data.data.media;
        if(this.media.custom_tag) {
          this.modelCustom = true;
        } else {
          this.modelCustom = false;
        }
        if(this.media.hasOwnProperty('comment_mode') && this.media.comment_mode) {
          this.modelCommentMode = this.media.comment_mode;
        } else {
          this.modelCommentMode = false;
        }
        
        this.flagFetchedMedia = true;
        this.fetchAdmin();
        this.fetchTags();
        this.fetchTagTemplates();
      });
    },
    fetchTags() {
      axios.get(this.$store.getters.urlApi + "tag/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        if(response.data.data.tags)
          this.tags = response.data.data.tags;
        this.flagFetchedTag = true;

      });
    },
    fetchAdmin() {
      axios.get(this.$store.getters.urlApi + "admin/channel/" + this.media.channel_id, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        var result = response.data.data.admin.user_ids.includes(this.$store.state.auth.user._id);
        if(!result && !this.$store.getters.isAdmin) {
          this.$router.back();
        }
      });
    },
    fetchTagTemplates() {
      axios.get(this.$store.getters.urlApi + "tagTemplate/channel/" + this.media.channel_id, {
        headers: {
        token: this.$store.state.auth.token
        }
      }
      ).then(response => {
        this.templates = response.data.data.templates;
        this.flagFetchedTagTemplate = true;
      });
    },

    // Event
    onClickCreateTag() {
      this.flagDialogCreate = true;
      this.modelName = "";
    },
    onCreateTag() {
      this.flagDialogCreate = false;
      axios.post(this.$store.getters.urlApi + "tag/media/" + this.mediaId, {
        'name': this.modelName,
        'color': this.modelColor,
        'backgroundColor': this.modelBgColor
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.fetchMedia();
        this.$toast.success(this.$t('toast.create'));
      });
    },
    onClickCreateTagTemplate() {
      this.flagDialogCreateTemplate = true;
      this.modelTemplateName = "";
    },
    onActionCreateTemplate() {
      this.flagDialogCreateTemplate = false;
      axios.post(this.$store.getters.urlApi + "tagTemplate/channel/" + this.media.channel_id, {
        'name': this.modelTemplateName,
        'tags': this.computedTagIds
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.fetchMedia();
        this.$toast.success(this.$t('toast.create'));
      });
    },
    onActionCancel() {
      this.flagDialogCreate = false;
    },
    onActionEditMedia() {
      axios.put(this.$store.getters.urlApi + "media/" + this.media._id, {
        custom_tag: this.modelCustom,
        comment_mode: this.modelCommentMode
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      );
    },
    onUpdateColor(color) {
      this.modelColor = color.rgba;
    },
    onUpdateBgColor(color) {
      this.modelBgColor = color.rgba;
    },
    onClickBack() {
      if(this.$route.params.fromChannel) {
        if(typeof this.$route.params.playlistId !== 'undefined') {
          this.$router.push({
            name: 'ChannelPlaylist',
            params: {
              channelId: this.media.channel_id,
              playlistId: this.$route.params.playlistId
            }
          });
        } else {
          this.$router.push({
            name: 'Channel',
            params: {
              channelId: this.media.channel_id
            }
          });
        }
      } else {
        if(typeof this.$route.params.playlistId !== 'undefined') {
          this.$router.push({
            name: 'PlaylistMedia',
            params: {
              mediaId: this.mediaId,
              playlistId: this.$route.params.playlistId
            }
          });
        } else {
          this.$router.push({
            name: 'Media',
            params: {
              mediaId: this.mediaId
            }
          });
        }
      }
    },
  },
}
</script>
